// src/pages/LoginPage.js
import React, { useState,useEffect } from 'react'; // 导入 useState hook
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'; // 导入 axios 用于发送 HTTP 请求
import ErrorAlert from '../components/ErrorAlert'; // 导入 ErrorAlert
import { Container, Box, Typography, TextField, Button, CssBaseline, Grid } from '@mui/material'; // Import Material UI components
import GoogleIcon from '@mui/icons-material/Google';
import GitHubIcon from '@mui/icons-material/GitHub';

const LoginPage = () => {

    console.log('LoginPage 组件被渲染了');

    // useEffect(() => {
    //   console.log('useEffect: LoginPage 挂载');
    // }, []);

  const [username, setUsername] = useState(''); // 用户名 state
  const [password, setPassword] = useState(''); // 密码 state
  const [error, setError] = useState('');     // 错误信息 state
  const [showErrorAlert, setShowErrorAlert] = useState(false); //  控制 ErrorAlert 组件显示
  const navigate = useNavigate(); // 初始化 useNavigate
  const location = useLocation(); // 初始化 useLocation
  const [socialAuthError, setSocialAuthError] = useState(''); //  State for social auth error message
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseErrorAlert = () => { //  关闭 ErrorAlert 的处理函数
    setShowErrorAlert(false);
    setError(''); //  同时清空 error state
	setSocialAuthError(''); //  Also clear socialAuthError when closing alert
  };
  
  useEffect(() => {
        //  Check for authError query parameter on component mount
        //const authErrorParam = location.searchParams.get('authError'); //  Get authError from query parameters
		const queryParams = new URLSearchParams(location.search);
		const authErrorParam = queryParams.get('authError');
        if (authErrorParam === 'google') {
            setSocialAuthError('Google 登录失败，请稍后重试'); //  Set Google auth error message
            setShowErrorAlert(true); // Show ErrorAlert
        } else if (authErrorParam === 'github') {
            setSocialAuthError('GitHub 登录失败，请稍后重试'); //  Set GitHub auth error message
            setShowErrorAlert(true); // Show ErrorAlert
        }
  }, [location.searchParams]); //  useEffect dependency on location.searchParams
	
  const handleSubmit = async (event) => { // 处理表单提交事件
    event.preventDefault(); // 阻止默认的表单提交行为
	setIsLoading(true); // 开始加载
    setError(''); // 清空错误信息
    setShowErrorAlert(false); //  隐藏 ErrorAlert

    try {
      const response = await axios.post('/auth/login', { // 发送 POST 请求到 /auth/login 接口
        username: username,
        password: password,
      });

      // 登录成功处理
      console.log('登录成功:', response.data);
      alert('登录成功！');

      console.log('Login success response.data (login endpoint):', response.data); // Log login response

      localStorage.setItem('token', response.data.token);

      // **NEW: Fetch user profile to get username**
      try {
          const profileResponse = await axios.get('/auth/me'); // **Replace /auth/me with your actual profile endpoint**
          console.log('Profile response.data:', profileResponse.data); // Log profile response
          localStorage.setItem('username', profileResponse.data.username); // **Adjust response.data.username to the correct field path**
          console.log('localStorage username after setItem (profile):', localStorage.getItem('username')); // Log after setting username from profile
      } catch (profileError) {
          console.error('Error fetching user profile:', profileError);
          // Handle profile fetch error if needed, maybe set a default username or show an error message
          localStorage.setItem('username', 'Guest'); // Example fallback username
      }
      // 登录成功后，根据用户之前的访问路径重定向，或者默认跳转到首页或个人资料页
      const redirectUrl = location.state?.from?.pathname || '/profile'; // 尝试获取之前的访问路径，否则默认为 /profile
      navigate(redirectUrl); //  使用 navigate 进行重定向
      // 或者 navigate('/profile'); //  直接跳转到个人资料页
      // 或者 navigate('/');      //  直接跳转到首页
      } catch (error) {
		  if (error.response) {
			  const { status } = error.response;
			  if (status === 401) {
				setError('用户名或密码错误');
			  } else if (status >= 500) {
				setError('服务器错误，请稍后重试');
			  }
			}
          console.error('登录失败:', error.response?.data?.message || '登录失败');
          setError(error.response?.data?.message || '登录失败');
          setShowErrorAlert(true); //  显示 ErrorAlert
      } finally {
		setIsLoading(false); // 结束加载
	}
  };

  return (
        <Container component="main" maxWidth="xs">
        {/* <CssBaseline /> */}
        <Box
            sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Typography component="h1" variant="h5">
                登录
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2, mb: 4 }}>
                请登录以访问更多功能。
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3, width: '100%' }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="username"
                    label="用户名"
                    name="username"
                    autoComplete="username"
                    autoFocus
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    error={!!error}
                    helperText={error}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="密码"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!error}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
					disabled={isLoading}
                    sx={{ mt: 3, mb: 2 }}
                >
                    {isLoading ? '登录中...' : '登录'}
                </Button>
                <Grid container sx={{ mt: 2 }}> {/* Grid container for social login buttons */}
                    <Grid item xs={12} sx={{ textAlign: 'center', mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            或使用以下方式登录
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ textAlign: 'center' }}> {/* Google button */}
                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<GoogleIcon />}
                            // onClick={() => { window.location.href = '/auth/google'; }} //  Old link - Direct to auth endpoint
							onClick={() => { window.location.href = '/auth/google/loading'; }} //  New link - To loading page
                            sx={{ mb: 1 }}
                        >
                            Google 登录
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{ textAlign: 'center' }}> {/* GitHub button */}
                        <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<GitHubIcon />}
                            // onClick={() => { window.location.href = '/auth/github'; }} // Old link - Direct to auth endpoint
							onClick={() => { window.location.href = '/auth/github/loading'; }} //  New link - To loading page
                        >
                            GitHub 登录
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ mt: 4, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    没有账号？
                    <Link to="/register" variant="body2" sx={{ ml: 1 }}>立即注册</Link>
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                    <Link to="/" variant="body2">返回首页</Link>
                </Typography>
            </Box>
        </Box>
    </Container>
    );
};

export default LoginPage;